import ArtistsTable from "./ArtistsTable";

export default ArtistsTable;
